import VisuraToastContainerRendering from "./visura-toast-container";

import * as visuraSlice from "../visura.slice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useRef } from "react";
const customId = "custom-id";

function VisuraToastContainer() {
  const dispatch = useDispatch();
  const status = useSelector(visuraSlice.selectStatus);
  const toastId = useRef(null);

  const handleSuccessFromApi = () => {
    if (!toast.isActive(toastId.current)) {
      toast.success(
        "file elaborato con successo premi il bottone copia negli appunti!",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          toastId: customId,
        }
      );
    }
  };

  const handleErrorFromApi = () => {
    dispatch(visuraSlice.clearStatus({ status: visuraSlice.Status.IDLE }));
    navigator.clipboard.writeText("");
    if (!toast.isActive(toastId.current)) {
      toast.error("Errore il file caricato non `e nel formato giusto!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        toastId: customId,
      });
    }
  };

  return (
    <VisuraToastContainerRendering
      status={status}
      onApiSuccess={handleSuccessFromApi}
      onApiError={handleErrorFromApi}
    />
  );
}

export default VisuraToastContainer;
